
const endpoints = {
    getPackages: (selectedOrg) =>
        `${process.env.REACT_APP_SERVER_HOST}/org/${selectedOrg}/marketplace/packages`,
    getOrg: (selectedOrg) =>
        `${process.env.REACT_APP_SERVER_HOST}/org/${selectedOrg}/details`,
};

export default endpoints;
